'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _animalInformation = require('./animal-information.html');

var _animalInformation2 = _interopRequireDefault(_animalInformation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

exports.default = {
  templateUrl: _animalInformation2.default,
  bindings: {
    adverseEvent: '<',
    animalTypes: '<',
    sexes: '<',
    locked: '<'
  },
  controller: function AnimalInformationComponent(EventEmitter) {
    'ngInject';

    _classCallCheck(this, AnimalInformationComponent);

    Object.assign(this, { EventEmitter: EventEmitter });
  }
};


// WEBPACK FOOTER //
// ./components/app/adverse-event/animal-information/animal-information.component.js